import Host from '@app/store/Host';

export default function isUserHost({
  currentUserContact,
  hosts,
}: {
  currentUserContact: string;
  hosts?: Host[];
}) {
  return !!hosts?.some((h) => h.contactInfo === currentUserContact);
}
